import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const TextCarasoul = () => {
  return (
    <div>
      <div className="max-w-[1000px] p-5 mx-auto">
        <Carousel
          showThumbs={true}
          showStatus={false}
          infiniteLoop
          //   emulateTouch
          //   autoPlay
          useKeyboardArrows
          transitionTime={1000}
          // axis="vertical"
          // selectedItem={1}
          width="100%"
        >
          <div className="p-10 mx-auto text-center text-white bg-black bg-opacity-90">
            <div class="md:p-10">
              <p className="text-xl text-center md:text-3xl">
                {`"The amount of content that I'm able to produce makes it worth
                the money."`}
              </p>
              <p className="mt-2 cursor-pointer text-2xl italic underline md:mt-5 text-[#f8cc84]">
                Josh McNair, California Through My Lens
              </p>
            </div>
          </div>
          <div className="p-10 mx-auto text-center text-white bg-black bg-opacity-90">
            <div class="md:p-10">
              <p className="text-xl text-center md:text-3xl">
                {`"I can't even keep up with the editor now because he's kicking my videos back to me so fast now that we have a process down."`}
              </p>
              <p className="mt-2 cursor-pointer text-2xl italic underline md:mt-5 text-[#f8cc84]">
                Mont Weaver, Vallet Media
              </p>
            </div>
          </div>
          <div className="p-10 mx-auto text-center text-white bg-black bg-opacity-90">
            <div class="md:p-10">
              <p className="text-xl text-center md:text-3xl">
                {`"Video Husky has alrady done a good job at putting that process into place where anybody who dosen't edit currently or have any editing skills can give a piece of video to an editor and get an amazing piece of video"`}
              </p>
              <p className="mt-2 cursor-pointer text-2xl italic underline md:mt-5 text-[#f8cc84]">
                Owen Hemsath, The Video Marketing School
              </p>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};

export default TextCarasoul;
